import { useState, useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Calendar, Sun, Hand, Briefcase } from "lucide-react";
import ScrollReveal from "@/components/animations/ScrollReveal";

const NotOfficeSection = () => {
  const { t } = useLanguage();
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    let rafId: number;
    const handleScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        setScrollY(window.scrollY);
      });
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  const narrativeLines = [
    { icon: Calendar, key: "notOffice.line1" },
    { icon: Sun, key: "notOffice.line2" },
    { icon: Hand, key: "notOffice.line3" },
  ];

  return (
    <section className="py-24 md:py-32 lg:py-40 bg-sand-100 relative z-20 overflow-hidden">
      {/* Decorative elements with parallax */}
      <div
        className="absolute top-0 right-0 w-96 h-96 bg-forest-700/5 rounded-full blur-3xl"
        style={{ transform: `translateY(${scrollY * 0.1}px)` }}
      />
      <div
        className="absolute bottom-0 left-0 w-64 h-64 bg-teal-500/10 rounded-full blur-3xl"
        style={{ transform: `translateY(${scrollY * -0.05}px)` }}
      />
      <div
        className="absolute top-1/2 left-1/3 w-48 h-48 bg-sun-400/5 rounded-full blur-3xl"
        style={{ transform: `translateY(${scrollY * 0.08}px)` }}
      />

      <div className="container mx-auto px-md lg:px-lg relative z-10">
        <div className="max-w-3xl mx-auto flex flex-col gap-16 md:gap-24">
          {narrativeLines.map((line, index) => (
            <ScrollReveal key={index} delay={index * 300} threshold={0.7}>
              <div className="flex items-center gap-md justify-center">
                <line.icon className="h-8 w-8 md:h-10 md:w-10 text-forest-700 flex-shrink-0" />
                <p className="text-xl md:text-2xl lg:text-3xl font-medium text-forest-900">{t(line.key)}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NotOfficeSection;
